// extracted by mini-css-extract-plugin
module.exports = {"PowerUp":"PowerUp_PowerUp__76POm","Enabled":"PowerUp_Enabled__Dchtr","Available":"PowerUp_Available__3cij_"};